import { Collection } from "src/app/platform/busines-data/Campaigns/Collection";
import { Region } from "src/app/platform/busines-data/Framework/Region";
import { Section } from "src/app/platform/busines-data/Framework/Section";

/**
 * Adds to `campaign` an empty copy of `source` (same Guid and Name, one empty Section
 * per source section) with its groups wired under the campaign's, and returns it.
 * `css` also wires the css groups (the sensor campaign renders CSS3D labels; the
 * inspection campaign does not). A region the campaign already holds is returned as is.
 */
export function addCampaignRegion(campaign: Collection, source: Region, options: { css: boolean }): Region {
    const existing = campaign.regionsWorkableElements.find(region => region.Guid === source.Guid);
    if (existing) return existing;

    const region = new Region(source.Guid, source.Name);
    for (const sourceSection of source.sections) {
        const section = new Section(sourceSection.Guid, sourceSection.Name);
        region.sections.push(section);
        region.group.add(section.group);
        if (options.css) region.cssGroup.add(section.cssGroup);
    }
    campaign.group.add(region.group);
    campaign.regionsWorkableElements.push(region);
    if (options.css) campaign.cssGroup.add(region.cssGroup);
    return region;
}
